import { type FC, type PropsWithChildren, useId } from 'react';

import { Box, Card, Stretch } from '@eneco/sparky';

import {
  ProductCardContent,
  ProductCardFrame,
  type ProductCardContentProps,
  type ProductCardFrameProps,
} from './ProductCardContent';

interface Props extends Omit<ProductCardContentProps, 'titleSuffix'>, ProductCardFrameProps {
  isOpen?: boolean;
}

export const PromotionCard: FC<PropsWithChildren<Props>> = ({
  title,
  subtitle,
  ribbon,
  touRibbon,
  tag,
  price,
  secondaryPrice,
  isOpen,
  usps,
  children,
}) => {
  const contentId = useId();
  const WrapperComponent = isOpen ? Box : Stretch;

  return (
    <WrapperComponent>
      <ProductCardFrame ribbon={ribbon} touRibbon={touRibbon}>
        <Card>
          <ProductCardContent
            id={contentId}
            title={title}
            subtitle={subtitle}
            tag={tag}
            price={price}
            secondaryPrice={secondaryPrice}
            usps={usps}>
            {children}
          </ProductCardContent>
        </Card>
      </ProductCardFrame>
    </WrapperComponent>
  );
};
